export const appDomain = process.env.REACT_APP_APP_DOMAIN
/**
 * Cookiee helper function
 * @param {Cookiee Name} cName
 * @param {Cookiee Value} cValue
 */
export const setCookie = (cName, cValue) => {
  let cookie = `${cName}=${cValue};path=/;`
  if (appDomain.indexOf('localhost') === -1) {
    cookie += `domain=${appDomain}`
  }
  document.cookie = cookie
}

/**
 * Cookiee helper function
 * @param {Cookiee Name} cName
 * @returns
 */
export const getCookie = (cName) => {
  const name = `${cName}=`
  const cDecoded = decodeURIComponent(document.cookie) // to be careful
  const cArr = cDecoded.split('; ')
  let res
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length)
  })
  return res
}

/**
 * Cookie helper function to delete a cookie
 * @param {string} cName - Cookie name to delete
 */
export const deleteCookie = (cName) => {
  let cookie = `${cName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`
  if (appDomain.indexOf('localhost') === -1) {
    cookie += `domain=${appDomain}`
  }
  document.cookie = cookie
}
